import { trackById, trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TenantSensor } from "src/app/models/tenantSensor.model";
import { TenantSensorService } from "src/app/services/tenantSensor.service";
import { ToastService } from "src/app/services/toast.service";
import { TenantService } from "src/app/services/tenant.service";
import { TenantLookup } from "src/app/models/tenantLookup.model";
import { DateFormatService } from "src/app/services/dateFormat.service";
import { DeviceVersion } from "src/app/models/deviceVersion.model";
import { DeviceVersionService } from "src/app/services/deviceVersionService";
import { forkJoin } from "rxjs";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { TenantSensorOrgLevelDialogBase } from "../tenantSensorOrgLevelDialog.base";
import { SensorDataTypeEnum } from "src/app/enums/sensorDataType.enum";

@Component({
  standalone: false,
    selector: "app-create-tenant-sensor-dialog",
    templateUrl: "createTenantSensorDialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["createTenantSensorDialog.component.scss"],
})
export class CreateTenantSensorDialogComponent extends TenantSensorOrgLevelDialogBase implements OnInit {
    isFormLoading = false;
    isLoading = false;
    tenants: TenantLookup[];
    deviceVersions: DeviceVersion[];
    tableNames = [
        SensorDataTypeEnum.ParticulateTimeseries,
        SensorDataTypeEnum.OpcR2,
        SensorDataTypeEnum.NoiseTimeseries,
        SensorDataTypeEnum.AirNowMonitoring,
        SensorDataTypeEnum.GasData,
    ];

    constructor(
        public dialogRef: MatDialogRef<CreateTenantSensorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public sensor: TenantSensor,
        private tenantSensorService: TenantSensorService,
        private tenantService: TenantService,
        private deviceVersionService: DeviceVersionService,
        private dateFormatService: DateFormatService,
        private toastService: ToastService,
        organizationLevelService: OrganizationLevelService,
    ) {
        super(organizationLevelService);
    }

    ngOnInit() {
        this.isFormLoading = true;
        forkJoin({
            tenants: this.tenantService.getTenantLookupList(),
            deviceVersions:
                this.deviceVersionService.getDeviceVersionLookupList(),
        }).subscribe(
            (result) => {
                this.tenants = result.tenants;
                this.deviceVersions = result.deviceVersions;
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    public trackById = trackById;
    public trackByIndex = trackByIndex;

    create() {
        const latitude = this.sensor.latitude;
        if (latitude !== undefined && (latitude < -90 || latitude > 90)) {
            this.toastService.showWarning(
                "Latitude must be between -90 and 90.",
                true,
            );
            return;
        }

        const longitude = this.sensor.longitude;
        if (longitude !== undefined && (longitude < -180 || longitude > 180)) {
            this.toastService.showWarning(
                "Longitude must be between -180 and 180.",
                true,
            );
            return;
        }

        this.isLoading = true;
        this.sensor.installDate = this.dateFormatService.formatDateTimeToString(
            this.sensor.installationDate,
            this.dateFormatService.dateToStringWithTimeFormat,
        );
        this.tenantSensorService.createTenantSensor(this.sensor).subscribe(
            (response) => {
                this.isLoading = false;
                this.toastService.showSuccess(
                    "Sensor added successfully",
                    true,
                );
                this.dialogRef.close(true);
            },
            (error) => {
                this.isLoading = false;
                this.toastService.showError(error);
            },
        );
    }
}
